document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.tw-header--transparent');

  var announcementBar = document.querySelector('.announcement-bar');
  if (announcementBar) {
    var setAnnouncementHeight = function () {
      document.documentElement.style.setProperty(
        '--tw-announcement-bar-height',
        announcementBar.getBoundingClientRect().height + 'px'
      );
    };

    setAnnouncementHeight();
    window.addEventListener('resize', setAnnouncementHeight);

    // Text can reflow after the async Google Fonts swap (see theme.liquid),
    // which changes the bar's wrapped height without firing a resize event.
    if (window.ResizeObserver) {
      new ResizeObserver(setAnnouncementHeight).observe(announcementBar);
    }
  }

  if (!header) return;

  var toggle = function () {
    header.classList.toggle('tw-scrolled', window.scrollY > 10);
  };

  toggle();
  window.addEventListener('scroll', toggle, { passive: true });
});
